import React, { useState } from 'react';
import axios from 'axios';
import { Form, FormSpy } from 'react-final-form';
import { Column, Button, Text, Flex } from '../../design-system';
import Alert from '../../helpers/alert';
import { ERR_MSG } from '../../globalConstants';
import FieldColumn from '../../components/FieldColumn';
import { required, emailVal, composeValidators } from '../../helpers/utils';
import GrantholsterBrand, {
  MainContainer,
  FormContainer,
  StyledBlockLink,
  SuccessfulSubmission,
} from '../../components/GrantholsterBrand';

const ForgotPassword = () => {
  const [isEmailResetLinkSent, setIsEmailResetLinkSent] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState(false);

  const onSubmit = async (email: Record<string, string>) => {
    try {
      const response = await axios.post('/auth/password/email', email);
      if (response.status === 200) {
        setIsEmailResetLinkSent(true);
        Alert.success('Email reset link has been sent');
      }
    } catch (error: any) {
      Alert.error(ERR_MSG);
    }
  };

  return (
    <MainContainer fluid>
      <Flex height="100%">
        <Column width="50%" justifyContent="center" alignItems="center">
          {isEmailResetLinkSent ? (
            <SuccessfulSubmission alignItems="center">
              <Text> Check your email for a reset link</Text>
              <StyledBlockLink to="/login" color="blue">
                Login
              </StyledBlockLink>
            </SuccessfulSubmission>
          ) : (
            <>
              <Text mb={20} fontSize={20}>
                Forgot your password?
              </Text>
              <FormContainer>
                <Form
                  onSubmit={onSubmit}
                  render={({ handleSubmit, submitting, pristine }) => (
                    <form onSubmit={handleSubmit}>
                      <FormSpy
                        subscription={{ valid: true }}
                        onChange={(state: { valid: boolean }) => {
                          const { valid } = state;
                          setIsValidEmail(valid);
                        }}
                      />
                      <FieldColumn
                        name="email"
                        placeholder="Email"
                        validate={composeValidators(required, emailVal)}
                        width="100%"
                      />
                      <Column mt={1} flexDirection="column">
                        <Button
                          type="submit"
                          disabled={submitting || pristine || !isValidEmail}
                        >
                          Send recovery link
                        </Button>
                      </Column>
                      <Flex>
                        <StyledBlockLink to="/login">
                          Return to log in
                        </StyledBlockLink>
                      </Flex>
                    </form>
                  )}
                />
              </FormContainer>
            </>
          )}
        </Column>

        <GrantholsterBrand />
      </Flex>
    </MainContainer>
  );
};

export default ForgotPassword;
